import React from "react";

const ContextPasteRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.4 5.40005C13.1732 5.40005 13.8 6.02685 13.8 6.80005L13.8 12.2C13.8 13.0837 13.0837 13.8 12.2 13.8L6.80005 13.8C6.02685 13.8 5.40005 13.1732 5.40005 12.4",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.99995 2.19995H3.79995C2.9163 2.19995 2.19995 2.9163 2.19995 3.79995V8.99995C2.19995 9.88361 2.9163 10.6 3.79995 10.6H8.99995C9.88361 10.6 10.6 9.88361 10.6 8.99995V3.79995C10.6 2.9163 9.88361 2.19995 8.99995 2.19995Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ContextPasteRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;